import { Tour } from 'antd';
import styled from 'styled-components';

export default styled(Tour)`
	// Add your styles here
`;
